import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import {store} from "./State/store";
import {setMaxValueAC, setMinValueAC} from "./State/AppStateReducer";

const savedMaxValue = localStorage.getItem('maxValue');
const savedMinValue = localStorage.getItem('minValue');

if (savedMaxValue && savedMinValue) {
    store.dispatch(setMaxValueAC(parseInt(savedMaxValue)));
    store.dispatch(setMinValueAC(parseInt(savedMinValue)));
}
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <Provider store={store}>
    <App/>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
